import { render, staticRenderFns } from "./ForgetPassword_2.vue?vue&type=template&id=4f4749e8&"
import script from "./ForgetPassword_2.vue?vue&type=script&lang=js&"
export * from "./ForgetPassword_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports